var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.675 3.048 6.558 4.733l-.156.124.085.18 1.623 3.41.143.298.248-.219 5.537-4.876 1.61 19.15-4.476-8.457-.153-.288-.239.222-3.053 2.848-4.603-8.988-.146-.286-.242.212-2.334 2.052L2.5.352l6.175 2.696Z",
    fill: "#9A85F5",
    stroke: "#542F04",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
};
export { SvgFlash as ReactComponent };